import React, { useEffect } from 'react';
import { Modal } from '@mui/material';
import { Button } from '../../components/ui';
import { useForm } from 'react-hook-form';
import Input from '../../components/ui/Input';
import InputArea from '../../components/ui/InputArea';
import { PrimaryLoader, InlineLoader } from '../../components/Loader';

const AddLocationModal = ({ open, onClose, onSave, isEditing = false, initialData = null, isLoading = false, isSubmitting = false }) => {
  const { control, handleSubmit, formState: { errors }, reset } = useForm({
    defaultValues: {
      name: '',
      address_1: '',
      lat: '',      
      long: '',     
      radius: '',
    }
  });

  // Reset form values when initialData changes or when opening/closing the modal
  useEffect(() => {
    if (open) {
      if (isEditing && initialData) {
        // No need to map field names anymore as they match
        reset({
          name: initialData.name || '',
          address_1: initialData.address_1 || '',
          lat: initialData.lat || '',
          long: initialData.long || '',
          radius: initialData.radius || '',
        });
      } else {
        // Reset to empty values for new creation
        reset({
          name: '',
          address_1: '',
          lat: '',
          long: '',
          radius: '',
        });
      }
    }
  }, [open, initialData, isEditing, reset]);

  const onSubmit = (data) => {
    onSave(data);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="add-location-modal-title"
      aria-describedby="add-location-modal-description"
    >
      <div className="w-[60%] bg-white absolute left-1/2 -translate-x-1/2 top-[10%] p-6 rounded-md max-h-[80vh] overflow-y-auto">
        <h2 className="text-xl font-bold mb-4">
          {isEditing ? 'Edit Geofence Location' : 'Add New Geofence Location'}
        </h2>
        
        {isLoading && isEditing ? (
          <PrimaryLoader />
        ) : (
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <Input
              label="Location Name"
              name="name"
              control={control}
              rules={{ required: "Location name is required" }}
              placeholder="Enter location name"
            />
            
            <InputArea
              label="Address"
              name="address_1"  // Changed from address to address_1
              control={control}
              rows={4}
              placeholder="Enter address (optional)"
            />
            
            <div className="grid grid-cols-2 gap-4">
              <Input
                label="Latitude"
                name="lat"  // Changed from latitude to lat
                type="number"
                step="0.000001"
                control={control}
                rules={{ required: "Latitude is required" }}
                placeholder="Enter latitude (e.g., 28.6139)"
              />
              
              <Input
                label="Longitude"
                name="long"  // Changed from longitude to long
                type="number"
                step="0.000001"
                control={control}
                rules={{ required: "Longitude is required" }}
                placeholder="Enter longitude (e.g., 77.2090)"
              />
            </div>
            
            <Input
              label="Radius (in meters)"
              name="radius"
              type="number"
              control={control}
              rules={{ 
                required: "Radius is required",
                min: { value: 1, message: "Radius must be at least 1 meter" }
              }}
              placeholder="Enter radius in meters"
            />
            
            <div className="flex justify-end space-x-3 pt-4">
              <Button 
                variant="ghost" 
                onClick={onClose} 
                type="button"
                disabled={isSubmitting}
              >
                Cancel
              </Button>
              <Button 
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <InlineLoader className="text-white mr-2" />
                    {isEditing ? 'Updating...' : 'Saving...'}
                  </>
                ) : (
                  isEditing ? 'Update' : 'Save'
                )} Location
              </Button>
            </div>
          </form>
        )}
      </div>
    </Modal>
  );
};

export default AddLocationModal;
